import { useEffect } from 'react';
import { useFormikContext } from 'formik';
export const NewslettersFormHelper = ({ setIsFormSubmitted }) => {
    const { submitCount } = useFormikContext();
    useEffect(() => {
        if (submitCount > 0) {
            setIsFormSubmitted(true);
        }
    }, [setIsFormSubmitted, submitCount]);
    return null;
};
